import Swiper from 'swiper';
import { Pagination, Navigation, Scrollbar } from 'swiper';
import { getDisplayMode } from '../common/libs.js';

const setSlider = () => {
  const targetSliders = document.querySelectorAll(".js-slider");

  targetSliders.forEach(Slider => {
    const slideLength = Slider?.querySelectorAll(".swiper-slide").length;
    let first = false;
    let windowWidth = Slider?.clientWidth;
    let slideSize = 0;
    let slideSpace = 0;
    if (getDisplayMode() == 1) {
      slideSize = 364;
      slideSpace = 35;
    } else {
      slideSize = 300;
      slideSpace = 25;
    }
    let viewSlideLength = Math.floor(windowWidth / (slideSize + slideSpace));

    const Section = Slider.closest('.section')

    if (slideLength > viewSlideLength) {
      var swiper = new Swiper(Slider, {
        modules: [Pagination,Navigation,Scrollbar],
        speed: 500,
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: slideSpace,
        // centeredSlides: true,
        // pagination: {
        //   el: MsgSection.querySelector('.swiper-pagination'),
        //   clickable: true,
        //   type: 'bullets',
        // },
        scrollbar: {
          el: Section.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
        navigation: {
          nextEl: Section.querySelector('.swiper-button-next'),
          prevEl: Section.querySelector('.swiper-button-prev'),
        },
      });
    } else {
      Slider?.classList.add('slide-none');
      // const navButtons = MsgSlider.closest('.section-content')?.querySelector('.swiper-button-wrapper');
      // navButtons?.classList.add('slide-none');
    }

    Slider?.classList.add('is-init')
  })
}

export default setSlider;